module.exports = __webpack_public_path__ + "static/media/roadmap-image.62a82435.webp";